import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AnswerValueDto, QuizProgress } from '../models';
import { QuizProgressDto } from '../models/progress.dto';

@Injectable({
    providedIn: 'root',
})
export class QuizProgressHttpService {
    private readonly httpClient = inject(HttpClient);

    getProgress(quizId: string): Observable<QuizProgress> {
        return this.httpClient.get<QuizProgressDto>(`api/v1/library/quizzes/${quizId}/progress`).pipe(map((dto) => new QuizProgress(dto)));
    }

    saveAnswer(quizId: string, questionId: string, optionId: number): Observable<QuizProgress> {
        const body = new AnswerValueDto(optionId);
        return this.httpClient.put<QuizProgressDto>(`api/v1/library/quizzes/${quizId}/answers/${questionId}`, body).pipe(map((dto) => new QuizProgress(dto)));
    }

    retry(quizId: string): Observable<void> {
        return this.httpClient.delete<void>(`api/v1/library/quizzes/${quizId}/progress`);
    }
}
